import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';
import { hexToRGBA } from '_helpers/theme';

import CardIcon from 'components/shared/CardIcon';
import Text from 'components/shared/layouts/Text';

const StyledContainer = styled.div`
  width: 100%;
  padding: ${theme.spaces.regular}px;
  border-radius: 4px;
  border: 1px solid ${hexToRGBA(theme.colors.gray.secondary, 0.16)};
`;

const StyledCardNumberContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  margin-bottom: ${theme.spaces.regular}px;
`;

const PaymentMethodCard = ({ cardType, cardNumber, cardMonth, cardYear }) => (
  <StyledContainer>
    <Text size={theme.fontSizes.smallX} weight={600} color={theme.colors.gray.secondary}>
      CARD NUMBER
    </Text>
    <StyledCardNumberContainer>
      <CardIcon cardType={cardType} />
      <Text weight={600}>**** **** **** {cardNumber}</Text>
    </StyledCardNumberContainer>
    <Text size={theme.fontSizes.smallX} weight={600} color={theme.colors.gray.secondary}>
      EXPIRES
    </Text>
    <Text weight={600}>
      {cardMonth} / {cardYear}
    </Text>
  </StyledContainer>
);

PaymentMethodCard.propTypes = {
  cardType: PropTypes.string,
  cardNumber: PropTypes.string,
  cardMonth: PropTypes.string,
  cardYear: PropTypes.string,
};

export default PaymentMethodCard;
